import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const InsightsRoutes: RouteBundle = {
  domain: 'insights',
  routes: [
    {
      urlPattern: 'analytics',
      handler: EditorRoutes.externalAnalyticsListing.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'analytics/dashboards/:analyticsDashboardUrlIdentifier',
      handler: externalAnalyticsDashboardDetails,
      legacy: true,
    },
  ],
};

function externalAnalyticsDashboardDetails(analyticsDashboardUrlIdentifier: string): void {
  const analyticsDashboardId = analyticsDashboardUrlIdentifier.split('-', 1)[0];
  EditorRoutes.externalAnalyticsDashboardDetails(analyticsDashboardId);
}
